<template>
  <vx-card class="editor-mid-card">
    <!-- <vue-perfect-scrollbar class="scroll-area" :settings="settings"> -->
    <div class="mb-base">
      <div class="flex justify-between flex-wrap">
        <vs-row vs-w="6">
          <h3 class="float-left mr-4">
            {{ $t("editor.educationalQualifications.title") }}
          </h3>
          <vx-tooltip v-if="saveInProgress" text="Saving to cloud...">
            <feather-icon
              icon="CloudIcon"
              class="save-in-progress-status-icon"
              svgClasses="text-success"
          /></vx-tooltip>
          <vx-tooltip
            v-else
            :text="$t('editor.educationalQualifications.saveToCloud')"
            ><feather-icon
              icon="CloudIcon"
              class="save-in-progress-status-icon"
          /></vx-tooltip>
        </vs-row>
        <div>
          <options
            :previousMove="{ name: 'editor-career-history' }"
            :nextMove="{ name: 'editor-skills' }"
          />
        </div>
      </div>
      <!-- <p v-if="!isUserLoggedIn" class="text-danger">
          You are not authenticated. Please login to save your data.
        </p>
        <p v-else-if="internetConnectionStatus">
          Internet Connection Active. Keep editing and your data gets auto-saved.
        </p>
        <p v-else class="text-danger">
          No Internet Connection. Please connect to Internet to save your data.
        </p> -->
    </div>

    <div class="mb-2">
      <div>
        <div
          v-if="educationalQualifications.length"
          class="educational-qualification-block"
        >
          <VuePerfectScrollbar class="scroll-area--list" :settings="settings">
            <draggable
              v-model="educationalQualifications"
              :disabled="draggableDisabled"
              class="list-groupp"
              ghost-class="ghostt"
              :move="checkMove"
              @start="dragging = true"
              @change="updateOrder"
            >
              <vs-row
                class="mb-4"
                icon-pack="feather"
                icon="icon-move"
                :key="indextr"
                v-for="(tr, indextr) in educationalQualifications"
              >
                <vs-col
                  class="text-limited"
                  v-if="tr.degreeCertification"
                  vs-w="3"
                >
                  <feather-icon
                    icon="MoveIcon"
                    svgClasses="h-4 w-4"
                    class="mr-3 cursor-move"
                  />{{ tr.degreeCertification }}
                </vs-col>
                <vs-col v-else vs-w="3"
                  ><feather-icon
                    icon="MoveIcon"
                    svgClasses="h-4 w-4"
                    class="mr-3 cursor-move"
                  />{{
                    $t("editor.educationalQualifications.editDataToViewHere")
                  }}</vs-col
                >
                <vs-col class="text-limited" vs-w="3">
                  {{ tr.organization }}
                </vs-col>
                <!-- <vs-td v-else>None</vs-td> -->
                <vs-col vs-w="2">
                  {{ formatDate2(tr.startDate) }}
                </vs-col>
                <!-- <vs-td v-else>None</vs-td> -->
                <vs-col vs-w="2">
                  {{ formatDate2(tr.endDate) }}
                </vs-col>
                <!-- <vs-td v-else>None</vs-td> -->
                <vs-col class="whitespace-no-wrap flex items-center" vs-w="2">
                  <vx-tooltip
                    :text="
                      $t(
                        'editor.educationalQualifications.tooltips.editEducationQualification'
                      )
                    "
                    position="bottom"
                  >
                    <feather-icon
                      icon="EditIcon"
                      class="mx-1"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current cursor-pointer"
                      @click.stop="editEducationalQualification(tr)"
                    />
                  </vx-tooltip>
                  <vx-tooltip
                    :text="
                      $t(
                        'editor.educationalQualifications.tooltips.deleteEducationQualification'
                      )
                    "
                    position="bottom"
                  >
                    <feather-icon
                      icon="TrashIcon"
                      svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer"
                      class="ml-2"
                      @click.stop="deleteEducationalQualification(tr._id)"
                    />
                  </vx-tooltip>
                </vs-col>
              </vs-row>
            </draggable>
          </VuePerfectScrollbar>
        </div>
        <div v-else class="items-center">
          {{ $t("editor.utils.noDataAvailable") }}
        </div>
      </div>
    </div>

    <div v-if="isUserLoggedIn" class="flex justify-between flex-wrap mb-base">
      <p
        class="add-experience-btn text-primary font-bold"
        @click="addEducationalQualification()"
      >
        <u
          >+
          {{
            $t("editor.educationalQualifications.addEducationalQualification")
          }}</u
        >
      </p>
    </div>
    <p v-else>
      <span v-if="organizationSlug === 'default'">
        <router-link :to="{ name: 'editor-about' }">{{
          $t("editor.educationalQualifications.login")
        }}</router-link>
        {{
          $t(
            "editor.educationalQualifications.toAddYourEducationalQualifications"
          )
        }}
      </span>
      <span v-else>
        <router-link :to="{ name: 'editor-about-custom' }">{{
          $t("editor.educationalQualifications.login")
        }}</router-link>
        {{
          $t(
            "editor.educationalQualifications.toAddYourEducationalQualifications"
          )
        }}
      </span>
    </p>

      <div
        v-if="addForm"
        class="main-form mb-base"
      >
        <div class="vx-row">
          <div class="vx-col mb-base w-full md:w-1/2">
            <label>{{ $t('editor.educationalQualifications.degreeCertification') }}<span class="required-field">*</span></label>
            <vs-input
              class="w-full dark-input-field"
              name="Degree/Certification"
              maxlength = "250"
              data-vv-validate-on="blur"
              v-validate="'required'"
              :disabled="disableInputField"
              v-model="localData.degreeCertification"
              @blur="saveField('saveEQDegreeCertification', 'Degree/Certification')"
            />
            <span class="text-danger text-sm">{{ errors.first("Degree/Certification") }}</span>
          </div>
          <div class="vx-col mb-base w-full md:w-1/2">
            <label>{{ $t('editor.educationalQualifications.organization') }}<span class="required-field">*</span></label>
            <vs-input
              class="w-full dark-input-field"
              name="Organization"
              maxlength = "250"
              data-vv-validate-on="blur"
              v-validate="'required'"
              :disabled="disableInputField"
              v-model="localData.organization"
              @blur="saveField('saveEQOrganization', 'Organization')"
            />
            <span class="text-danger text-sm">{{ errors.first("Organization") }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full md:w-1/2">
            <div class="vx-row">
              <div class="vx-col mb-base w-full md:w-1/2">
                <label>{{ $t('editor.educationalQualifications.startDate') }}<span class="required-field">*</span></label>
                <vs-input
                  v-validate="'required'"
                  data-vv-validate-on="blur"
                  :max="localData.endDate"
                  name="Start Date"
                  type="date"
                  icon-no-border
                  v-model="localData.startDate"
                  class="w-full mr-3 dark-input-field"
                  @blur="saveField('saveEQStartDate', 'Start Date')"
                  :disabled="disableInputField"
                />
                <span class="text-danger text-sm">{{
                  errors.first("Start Date")
                }}</span>
              </div>
              <div class="vx-col mb-base w-full md:w-1/2">
                <label>{{ $t('editor.educationalQualifications.endDate') }}<span class="required-field">*</span></label>
                <vs-input
                  name="End Date"
                  type="date"
                  icon-no-border
                  :min="localData.startDate"
                  v-model="localData.endDate"
                  class="w-full mr-3 dark-input-field"
                  @blur="saveField('saveEQEndDate')"
                  :disabled="disableInputField || localData.currentlyActive"
                />
                <small><i>({{ $t('editor.educationalQualifications.orExpected') }})</i></small>
              </div>
            </div>
          </div>
          <div class="vx-col mb-base w-full md:w-1/2">
            <label>{{ $t('editor.educationalQualifications.scorePercentage') }}</label>
            <vs-input
              class="w-full dark-input-field"
              name="Grade"
              type="number"
              :disabled="disableInputField"
              v-model="localData.grade"
              @blur="saveField('saveEQGrade')"
            />
            <span class="text-danger text-sm">{{ errors.first("Grade") }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full md:w-1/2">
            <div class="vx-row">
              <div class="vx-col sm-mb-base w-full md:w-1/2">
                <label>{{ $t('editor.educationalQualifications.country') }}<span class="required-field">*</span></label>
                <vs-select
                  class="w-full"
                  v-model="localData.country"
                  :disabled="disableInputField"
                  @input="saveField('saveEQCountry')"
                  >
                  <vs-select-item v-for="(item,index) in countryCodes" :key="index" :value="item.label" :text="item.label"  />
                </vs-select>
                <span class="text-danger text-sm">{{
                  errors.first("Country")
                }}</span>
              </div>
              <div class="vx-col sm-mb-base w-full md:w-1/2">
                <label>{{ $t('editor.educationalQualifications.city') }}<span class="required-field">*</span></label>
                <vs-select
                  v-if="cityList.length"
                  class="w-full"
                  v-model="localData.city"
                  :disabled="disableInputField || !localData.country"
                  @input="saveField('saveEQCity')"
                  >
                  <vs-select-item v-for="(item,index) in cityList" :key="index" :value="item.label" :text="item.label"  />
                </vs-select>
                <vs-select
                  v-else
                  class="w-full"
                  :disabled="disableInputField || !localData.country"
                  v-model="localData.city"
                  @input="saveField('saveEQCity')"
                  >
                  <vs-select-item value="No cities are found !" text="No cities are found !" />
                </vs-select>

                <span class="text-danger text-sm">{{
                  errors.first("City")
                }}</span>
              </div>
            </div>
          </div>
          <div class="vx-col sm-mb-base w-full md:w-1/2">
            <label>{{ $t('editor.educationalQualifications.description') }}</label>
            <vs-textarea
              class="w-full"
              name="Description"
              maxlength = "2600"
              :disabled="disableInputField"
              v-model="localData.description"
              @blur="saveField('saveEQDescription')"
            />
          </div>
        </div>
      </div>
    <!-- </vue-perfect-scrollbar> -->
  </vx-card>
</template>

<script>
import FeatherIcon from "../../components/FeatherIcon.vue";
import Options from "./components/Options.vue";
import constants from "@/constants";
import {
  saveInputFieldService,
  deleteDocumentService,
} from "@/services/editor/educationalQualifications.service.js";
import DataList from "./components/DataList.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import _ from "lodash";
import draggable from "vuedraggable";
import moment from "moment";
import countryCodes from "@/assets/data/country-codes.js";
import allCountriesCities from "@/assets/data/all-countries-cities.js";
import vSelect from "vue-select";

export default {
  components: {
    FeatherIcon,
    Options,
    DataList,
    VuePerfectScrollbar,
    draggable,
    vSelect,
  },
  name: "EditorContact",
  data() {
    return {
      localData: {},
      addForm: false,
      selectedCHRow: {},
      constants,
      settings: {
        suppressScrollX: true,
        maxScrollbarLength: 40,
        wheelSpeed: 0.6,
      },
      draggableDisabled: false,
      countryCodes,
      allCountriesCities,
      maxDate: "",
    };
  },
  computed: {
    otpSent() {
      return this.$store.state.auth.otpSent;
    },
    saveInProgress() {
      return this.$store.state.editor.saveInProgress;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    usersData() {
      return this.$store.state.users.data;
    },
    /*educationalQualifications() {
      return this.$store.state.editor.educationalQualifications;
    },*/
    educationalQualifications: {
      get: function () {
        return this.$store.state.editor.educationalQualifications;
      },
      set: function (newVal) {
        this.$store.commit("editor/SET_EDUCATIONAL_QUALIFICATIONS", newVal);
      },
    },
    userId() {
      return this.$store.state.auth.user._id;
    },
    internetConnectionStatus() {
      return this.$store.state.users.internetConnectionStatus;
    },
    disableInputField() {
      return !this.isUserLoggedIn || !this.internetConnectionStatus;
    },
    scrollBarTag() {
      return "VuePerfectScrollbar";
    },
    organizationId() {
      return this.$store.state.organization.orgData._id;
    },
    organizationSlug() {
      return this.$store.state.organization.organizationSlug;
    },
    cityList() {
      if (this.localData.country in this.allCountriesCities) {
        const cityArr = this.allCountriesCities[this.localData.country];
        const newCityList = cityArr.map(city => {
          return {
            label: city
          };
        })
        return newCityList;
      } else {
        return [];
      }
    },
  },
  watch: {},
  methods: {  
    updateOrder(e) {
      _.debounce(
        function (currentThis) {
          const newEducationalQualification =
            currentThis.educationalQualifications.map(function (ch, index) {
              return { _id: ch._id, oldSortId: ch.sortId, newSortId: index };
            });

          newEducationalQualification.forEach((ch) => {
            currentThis.draggableDisabled = true;
            currentThis.$store
              .dispatch("editor/updateEducationalQualificationsOrder", {
                _id: ch._id,
                sortId: ch.newSortId,
              })
              .then((res) => {
                currentThis.draggableDisabled = false;
              });
          });
        },
        800,
        { leading: false, trailing: true }
      )(this);
    },
    checkMove: function (e) {
      // window.console.log("Future index: " + e.draggedContext.futureIndex);
    },
    formatDate(date) {
      if (date) {
        return date.split("T")[0];
      }
    },
    formatDate2(date) {
      if (date) {
        return moment(date).format("MMM YYYY");
      }
    },
    addEducationalQualification() {
      const sortId = this.educationalQualifications.length + 1;
      this.$store
        .dispatch("editor/createEducationalQualification", {
          userId: this.userId,
          sortId,
        })
        .then((res) => {
          this.localData = res.data;
          this.addForm = true;
          this.$forceUpdate();

          this.$vs.notify({
            title: "New Educational Qualification Created",
            text: "Start editing data and your data gets auto-saved.",
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success",
            fixed: false,
          });
        })
        .catch((err) => {
          this.$vs.notify({
            title: "Error creating a new Educational Qualification",
            text: "",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            fixed: false,
          });

          throw err;
        });
    },
    editEducationalQualification(data) {
      this.errors.clear();

      this.localData = JSON.parse(JSON.stringify(data));
      this.localData.startDate = this.formatDate(this.localData.startDate);
      this.localData.endDate = this.formatDate(this.localData.endDate);
      this.addForm = true;
    },
    deleteEducationalQualification(id) {
      this.errors.clear();

      this.deletionEQId = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this Educational Qualification entry?",
        acceptText: "Delete",
        accept: this.confirmDeleteEducationalQualification,
      });
      this.addForm = false;
      this.localData = {};
    },
    confirmDeleteEducationalQualification() {
      const payload = {
        isUserLoggedIn: this.isUserLoggedIn,
        educationalQualificationId: this.deletionEQId,
        currentThis: this,
      };

      deleteDocumentService(payload);
    },
    async saveField(action, fieldName = null) {  

      let fieldIsValid = false;


      //// console.log(this.localData);

      if (fieldName) {
        fieldIsValid = await this.$validator.validate(fieldName);

        if (!fieldIsValid) {
          return;
        }
      } else {
        fieldIsValid = true;
      }

      //// console.log(fieldIsValid);

      if (fieldName && !fieldIsValid) {
        return;
      }

      const payload = {
        isUserLoggedIn: this.isUserLoggedIn,
        action,
        localData: this.localData,
        educationalQualificationId: this.localData._id,
        currentThis: this,
      };

      //// console.log(this.localData, payload)

      saveInputFieldService(payload);
    },
    getTodayDate() {
      var d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return (this.maxDate = [year, month, day].join("-"));
    },
    preventNegativeKeyPress(event) {
      if (event.key === '-' || event.key === 'e' || event.key === 'E') {
        event.preventDefault();
      }
    }
  },
  mounted() {
    this.getTodayDate();
  },
  created() {
    this.$store.dispatch("editor/toggleRightBar", true);
    this.$store.dispatch("editor/togglePreviewMode", false);

    //// console.log("contact created");
  },
};
</script>

<style scoped>
.scroll-area--list {
  position: relative;
  margin: auto;
  height: 100px;
  width: 100%;
}
.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 615px;
  /*height: 1000px;*/
}
.educational-qualification-block {
  background: #f7f7f7;
  border-radius: 6px;
  padding: 10px 2px 10px 25px;
  overflow-x: auto;
}
.show-experience-on-map {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;

  color: #7c7c7c;

  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 12px 0px;
}

.currently-active {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  color: #7c7c7c;

  /* Inside Auto Layout */

  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 8px 0px;
}

.add-experience-btn {
  cursor: pointer;
}

.dark-input-field >>> .vs-con-input .vs-input--input {
  background: #edededab !important;
}
.vs-con-textarea >>> .vs-textarea {
  /* height: 60px !important; */
  background: #edededab !important;
}
</style>
